<template>
  <BreadCrumb :links="breadCrumbLinks" />
</template>

<script setup>
import { ref, watch, defineProps } from "vue";
import { generate } from "randomized-string";
import BreadCrumb from "../common/BreadCrumb.vue";
import { useRoute } from "vue-router";

const props = defineProps({
  entityName: {
    type: String,
    default: "",
  },
  ifrs: {
    type: String,
    default: "IFRS",
  },
});
const route = useRoute();
const name = ref(props.entityName);

const breadCrumbLinks = ref([
  {
    id: generate(),
    name: "Home",
    link: "/",
    disabled: false,
    active: false,
  },
  {
    id: generate(),
    name: "Entity",
    link: "/entity",
    disabled: false,
    active: false,
  },
  {
    id: "master-data",
    name: name,
    link: "/entity/master-data/" + route.params.id,
    disabled: false,
    active: false,
  },
  {
    id: "financial-data",
    name: "Financial Data",
    link: `/entity/financial-data/${route.params.id}?financial_year=${
      route.query.financial_year
    }&financial_period=${route.query.financial_period}${
      route.query.business ? "&business=" + route.query.business : ""
    }`,
    disabled: false,
    active: false,
  },
  {
    id: "profit-loss-view",
    name: "Profit and Loss",
    disabled: false,
    active: true,
    link: `/entity/financial-data/profit-loss/view/${
      route.params.id
    }?financial_year=${route.query.financial_year}&financial_period=${
      route.query.financial_period
    }${route.query.business ? "&business=" + route.query.business : ""}`,
  },
  {
    id: "profit-loss-income",
    name: "Income",
    link: `/entity/financial-data/profit-loss/income/${
      route.params.id
    }?financial_year=${route.query.financial_year}&financial_period=${
      route.query.financial_period
    }${route.query.business ? "&business=" + route.query.business : ""}`,
    disabled: false,
    active: false,
  },
  {
    id: "profit-loss-expenditure",
    name: "Expenditure",
    link: `/entity/financial-data/profit-loss/expenditure/${
      route.params.id
    }?financial_year=${route.query.financial_year}&financial_period=${
      route.query.financial_period
    }${route.query.business ? "&business=" + route.query.business : ""}`,
    disabled: false,
    active: false,
  },
]);

watch(
  () => route.query,
  (newValue) => {
    breadCrumbLinks.value = breadCrumbLinks.value.map((item) => {
      if (item.id === "financial-data") {
        return {
          ...item,
          link: `/entity/financial-data/${route.params.id}?financial_year=${
            route.query.financial_year
          }&financial_period=${route.query.financial_period}${
            route.query.business ? "&business=" + route.query.business : ""
          }`,
        };
      } else if (item.id === "profit-loss-view") {
        return {
          ...item,
          link: `/entity/financial-data/profit-loss/view/${
            route.params.id
          }?financial_period=${newValue.financial_period}&financial_year=${
            newValue.financial_year
          }${newValue.business ? "&business=" + newValue.business : ""}`,
        };
      } else if (item.id === "profit-loss-income") {
        return {
          ...item,
          link: `/entity/financial-data/profit-loss/income/${
            route.params.id
          }?financial_year=${newValue.financial_year}&financial_period=${
            newValue.financial_period
          }${newValue.business ? "&business=" + newValue.business : ""}`,
        };
      } else if (item.id === "profit-loss-expenditure") {
        return {
          ...item,
          link: `/entity/financial-data/profit-loss/expenditure/${
            route.params.id
          }?financial_period=${newValue.financial_period}financial_year=${
            newValue.financial_year
          }${newValue.business ? "&business=" + newValue.business : ""}`,
        };
      }
      return item;
    });
  },
  { deep: true }
);

watch(
  () => props.entityName,
  (newValue) => {
    breadCrumbLinks.value = breadCrumbLinks.value.map((item) => {
      if (item.id === "master-data") {
        return { ...item, name: newValue };
      }
      return item;
    });
  },
  { deep: true }
);
</script>

<style scoped></style>
